import * as React from "react";
import { Context } from "./_context";
export const TickerDownIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 3.5v7.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V3.5h1.5Z", fill: "currentColor" }));
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 5.5v10.086l2.793-2.793 1.414 1.414-4.5 4.5a1 1 0 0 1-1.34.066l-.074-.066-4.5-4.5 1.414-1.414L11 15.586V5.5h2Z", fill: "currentColor" }));
  return iconset[size];
};
TickerDownIcon.iconId = "iCxNT5";
